import IState from '../state';
import { IAccountAddress } from './models';

export const getIsAccountAddressComplete = ({ accountAddress }: IState): boolean => accountAddress.accountAddress.address.complete;
export const getAccountAddresses = ({ accountAddress }: IState): IAccountAddress[] => accountAddress.accountAddresses;
export const getAccountAddressesLoading = ({ accountAddress }: IState): boolean => accountAddress.loading;
